// Bridge verso window.ucampPush iniettato dall'app nativa (u-camp-app-admin).
// Nel browser il bridge non esiste: tutte le funzioni sono no-op, quindi
// la registrazione push avviene solo dentro l'app (push app-only).

function getNativeBridge() {
  if (typeof window === 'undefined') {
    return null
  }

  return window.ucampPush || null
}

export function isNativeApp() {
  const bridge = getNativeBridge()
  return Boolean(bridge && bridge.isNativeApp)
}

export async function getState() {
  const bridge = getNativeBridge()
  if (bridge && bridge.getState) {
    return bridge.getState()
  }

  return null
}

export async function requestPermission() {
  const bridge = getNativeBridge()
  if (bridge && bridge.requestPermission) {
    return bridge.requestPermission()
  }

  return null
}

export function onStateChange(handler) {
  if (typeof window === 'undefined') {
    return () => {}
  }

  const listener = (event) => {
    handler(event.detail)
  }

  window.addEventListener('ucamp-push-state', listener)
  return () => window.removeEventListener('ucamp-push-state', listener)
}
